// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDfmlFTHgjChe4PRBmdymKJq8M8gC2qaZo",
  authDomain: "viscer-15f26.firebaseapp.com",
  databaseURL:
    "https://viscer-15f26-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "viscer-15f26",
  storageBucket: "viscer-15f26.firebasestorage.app",
  messagingSenderId: "552289410608",
  appId: "1:552289410608:web:230180cbf7664cb27657f5",
  measurementId: "G-E3D8XWLGW4",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);
export const fs = getFirestore(app);
